import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { IUITKSelectItemProps } from '@uitk/angular';
import { Subscription } from 'rxjs';
import { Mode } from '../../../enums/mode.enum';
import { OrderDetailDto } from '../../../dtos/order-detail-dto.model';
import { ShippingDto } from '../../../dtos/shipping-dto.model';
import { GlDialogComponent } from '../../gl-dialog/gl-dialog.component';
import { AuthorizationService } from '../../../services/authorization.service';
import { ConfigService } from '../../../services/config.service';
import { ModeService } from '../../../services/mode.service';
import { OrderService } from '../../../services/order.service';
import { TokenizeService } from '../../../services/tokenize.service';
import { SwalAlert } from '../../../helpers/alert';
import { ChangeDetectorRef, NgZone } from '@angular/core';

@Component({
  selector: 'app-order-footer',
  templateUrl: './order-footer.component.html',
  styleUrls: ['./order-footer.component.css']
})

export class OrderFooterComponent implements OnInit, OnDestroy {
  private readonly _configService: ConfigService;
  private readonly _authorizationService: AuthorizationService;
  private readonly _tokenService: TokenizeService;
  @Output() addCheckOrCashRow = new EventEmitter<any>();
  @Output() changedShipVia = new EventEmitter<any>();
  configIsReadySubscription: Subscription | undefined;
  modeDisabled = true;
  isCCAuthDisabled = true;
  creditCardRequired = false;
  maxTaxRate = 0;
  isShipViaDisabled: boolean = false;
  isOrderFooterPODisabled : boolean = false;
  isOrderFooterPaymentPlanDisabled: boolean =false;
  paymentPlansList: IUITKSelectItemProps[] = []
  shippingMethods: ShippingDto[] = [];
  Mode = Mode;
  glStringError = false;
isGLTouched = false;

  methodList: IUITKSelectItemProps[] = []
  ccAuthList: IUITKSelectItemProps[] = []
  termsList: IUITKSelectItemProps[] = []
  termsListWithoutCreditCard: IUITKSelectItemProps[] = []
  isPaymentPlan = false;
  orderIsReadySubscription: Subscription | undefined;
  expirationDate = "";
  expDatePattern = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
  showExpDatePatternError = false;
  isPastDate: boolean = false;
  returnsData: OrderDetailDto[] = [];
  orderPaymentPlanBinding: string = '';
  orderPaymentMethodBinding: string | null = '';
  orderPaymentPlan: string = '';
  orderPaymentTerms = '';
  disablePaymentTerms = false;
  hasResourcePaymentMethodSOrN = false;
  hasResourcePaymentMethodC = false;
  hasResourceEditPaymentMethodC = false;
  hasOrderEntryPaymentMethodP = false;
  hasOrderEntryPaymentMethodY = false;
  hasMultipleGLs = false;
  displayGLString = '';
  private readonly creditCardText = 'Credit Card';
  swalAlert = new SwalAlert();

  get isPrivilegedUser(): boolean {
    const roleName = (localStorage.getItem('rolename') ?? '').replace(/\s+/g, '');
    return ['SystemAdministrator', 'OrderManagement', 'OrderManagementAdmin'].includes(roleName);
  }
  

  @ViewChild(GlDialogComponent) glDialogComponent!: GlDialogComponent;
  constructor(
    public orderService: OrderService,
    public modeService: ModeService,
    configService: ConfigService,
    authorizationService: AuthorizationService,
    tokenService: TokenizeService,
    private cdr: ChangeDetectorRef  
    
  ) {
    this._configService = configService;
    this._authorizationService = authorizationService;
    this._tokenService = tokenService;
  }

  ngOnInit(): void {
    if (!this._configService.reference) {
      throw new Error('References are not loaded.');
    }
      this.hasResourcePaymentMethodSOrN = this._configService.hasResource('OrderInquiryPaymentMethodSOrN');
      this.hasResourcePaymentMethodC = this._configService.hasResource('OrderInquiryPaymentMethodC');
      this.hasResourceEditPaymentMethodC = this._configService.hasResource('OrderInquiryEditPaymentMethodC');
      this.hasOrderEntryPaymentMethodP = this._configService.hasResource('OrderEntryPaymentMethodP');
      this.hasOrderEntryPaymentMethodY = this._configService.hasResource('OrderEntryPaymentMethodY');
    this.shippingMethods = this._configService.reference.shippingDtos;
    this.methodList = this._configService.getPickList("PMETH");
    this.ccAuthList = this._configService.getPickList("CCAUTH");
    this.paymentPlansList = this._configService.getPickList("PAYMNTPLAN");
    this.termsList = this._configService.getPickList("PTERMS").sort((a, b) => {
      return parseInt(a.value.slice(3, 6)) < parseInt(b.value.slice(3, 6)) ? -1 : 1
    });
    this.termsListWithoutCreditCard = this._configService.getPickList("PTERMS")
      .filter(x => x.value !== 'CC').sort((a, b) => {
        return parseInt(a.value.slice(3, 6)) < parseInt(b.value.slice(3, 6)) ? -1 : 1
      });
    if (!this._configService.hasResource("OrderInquiryPaymentMethodSOrN")) {
      this._configService.disablePickListOption(this.methodList, "S");
      this._configService.disablePickListOption(this.methodList, "N");
    }

    if (!this._configService.hasResource("OrderInquiryPaymentMethodC")) {
      this._configService.disablePickListOption(this.methodList, "C");
    }

    if (!this._configService.hasResource("OrderInquiryPaymentMethodCreditCard")) {
      this._configService.disablePickListOption(this.methodList, "V");
      this._configService.disablePickListOption(this.methodList, "M");
      this._configService.disablePickListOption(this.methodList, "D");
      this._configService.disablePickListOption(this.methodList, "X");
    }

    if (!this._configService.hasResource("OrderInquiryPaymentMethodI")) {
      this._configService.disablePickListOption(this.methodList, "I");
    }

    this.disablePaymentTerms = !this._configService.hasResource("OrderFooterTermsDropDown");
    this.isShipViaDisabled = !this._configService.hasResource("OrderFooterShipViaDropDown");
    this.isOrderFooterPODisabled = !this._configService.hasResource("OrderFooterPOTextBox");
    this.isOrderFooterPaymentPlanDisabled = !this._configService.hasResource("OrderFooterPaymentPlansDropDown");

    this.orderIsReadySubscription = this.orderService.orderIsReady.subscribe(() => {
      this.orderPaymentPlanBinding = this.orderService.orderDto.paymentPlan;
      this.orderPaymentMethodBinding = this.orderService.orderDto.paymentMethod;
      this.orderPaymentPlan = this.orderService.orderDto.paymentPlan;
      this.orderService.orderDto.lastShipmentMethod = this.orderService.orderDto.shipmentMethod;
      if (this.orderService.orderDto.paymentTerms)
      {
        this.orderPaymentTerms = this.orderService.orderDto.paymentTerms;
      }
      this.returnsData = JSON.parse(JSON.stringify(this.orderService.orderDto.orderDetailDtos));
      this.modeDisabled = (this.orderService.orderDto.paymentMethod === 'V'
        || this.orderService.orderDto.paymentMethod === 'M'
        || this.orderService.orderDto.paymentMethod === 'D'
        || this.orderService.orderDto.paymentMethod === 'X') ? false : true;
      if (!this._configService.hasResource("OrderFooterCCAuthDAuthorizedOption")){
        this._configService.disablePickListOption(this.ccAuthList, "A");
      }        
      this._configService.disablePickListOption(this.ccAuthList, "D");
      if (this._configService.hasResource("OrderFooterCCAuthD")){
          if(this.orderService.orderDto.ccAuthorizationCode==='A'){
            this.isCCAuthDisabled = true;
          }
          else{
            this.isCCAuthDisabled = false;
          }
      }
      this.orderService.recalculateFields(this.orderService.orderDto);

      if (this.orderService.orderDto.billToDto.accountTypeCode === "C"||this.orderService.orderDto.billToDto.accountTypeCode === "H") {
        this._configService.disablePickListOption(this.paymentPlansList, "Monthly");
        this._configService.disablePickListOption(this.paymentPlansList, "Quarterly");
      }

      if (this.orderService.orderDto.ccExpirationDate && this.orderService.orderDto.ccExpirationDate !== '') {
        this.expirationDate = this.orderService.orderDto.ccExpirationDate.substring(0, 2) + '/' + this.orderService.orderDto.ccExpirationDate.substring(2, 5);
      }
      this.syncGLStringFromService();
      this.cdr.detectChanges();
    });
  }

  async onChangePaymentPlanValue() {
    await this.callCashReceiptBR();
    await this.orderService.paymentPlanBR();
  }

  async callCashReceiptBR() {
    const cash = this.orderService.cashReceiptBR('', this.orderService.orderDto.paymentMethod, this.orderPaymentPlanBinding);
    if (cash === true) {
      await this.swalAlert.alert('Cash Receipts are not allowed on a payment plan');
    }
  }

  onShipViaChange(selected: string) {
    setTimeout(() => this.changedShipVia.emit());
  }
  onChangeIsRush(event: any): void {
    this.orderService.orderDto.isRush = event.value;
  }
  async onChangePaymentMethod(): Promise<void> {
    if (!this._configService.hasResource("OrderFooterCCAuthDAuthorizedOption")) {
      this._configService.disablePickListOption(this.ccAuthList, "A");
    }

    this._configService.disablePickListOption(this.ccAuthList, "D");
    
    if (!this._configService.hasResource("OrderFooterCCAuthD")) {
      this.isCCAuthDisabled = true;
    }
    else {
      this.isCCAuthDisabled = false;
    }

    if ((this.orderService.orderDto.paymentPlan === "Monthly" || this.orderService.orderDto.paymentPlan === "Quarterly")
      && (this.orderService.orderDto.paymentMethod === "C" || this.orderService.orderDto.paymentMethod === "N")) {
      await this.orderService.paymentPlanBR();
    }
    this.setPTermsOnChangePMethod();
    if (this.orderService.orderDto.paymentMethod === 'C') {
      this.addCheckOrCashRow.emit();
    }

    if ((((this.orderService.orderDto.paymentMethod === 'V'
      || this.orderService.orderDto.paymentMethod === 'M'
      || this.orderService.orderDto.paymentMethod === 'D'
      || this.orderService.orderDto.paymentMethod === 'X') && this.orderService.orderDto.ccAuthorizationCode === 'N') ||
      this.orderService.orderDto.paymentMethod === 'I') && this.orderService.orderDto.orderStatus === 'H') {
        if(this.orderService.orderDto.holdReasonCode==='1')//credit card is declined 
        {
          this.orderService.orderDto.orderStatus = ' ';
          this.orderService.orderDto.holdReasonCode = null;
        }     
      this.orderService.recalculateFields(this.orderService.orderDto);
    }
  }

  setPTermsOnChangePMethod() {
    if (this.orderService.orderDto.paymentMethod === 'V'
      || this.orderService.orderDto.paymentMethod === 'M'
      || this.orderService.orderDto.paymentMethod === 'D'
      || this.orderService.orderDto.paymentMethod === 'X') {
      this.orderService.orderDto.paymentTerms = this.creditCardText;
      this.orderService.orderDto.ccAuthorizationCode = 'N';
      this.modeDisabled = false;
    }
    else {
      this.orderService.orderDto.paymentTerms = this.orderPaymentTerms;
      
      if (this.orderService.orderDto.paymentTerms === this.creditCardText) {
        this.orderService.orderDto.paymentTerms = this.orderService.orderDto.billToDto.defaultPaymentTerms;
      }
      
      this.orderService.orderDto.ccToken = null;
      this.orderService.orderDto.ccExpirationDate = null;
      this.expirationDate = '';
      this.orderService.orderDto.ccLastFour = null;
      this.orderService.orderDto.ccAuthorizationCode = null;
      this.modeDisabled = true;
    }
  }
  expirationdate() {

    if(this.orderService.orderDto.holdReasonCode==='1')//credit card is declined 
        {
          this.orderService.orderDto.orderStatus = ' ';
          this.orderService.orderDto.holdReasonCode = null;
        }
        
    if (this.expirationDate.includes('/')) {
      this.orderService.orderDto.ccExpirationDate = this.expirationDate.replace("/", "");
    }
    else {
      if (this.expirationDate === '')
      {
        this.orderService.orderDto.ccExpirationDate = null;
      }
      else
      {
        this.orderService.orderDto.ccExpirationDate = this.expirationDate;
        this.expirationDate = this.orderService.orderDto.ccExpirationDate.substring(0, 2) + '/' + this.orderService.orderDto.ccExpirationDate.substring(2, 5);
      }
    }
  }

  expDateChange(expirationDate: string) {
    if (expirationDate !== "" && expirationDate !== null && !new RegExp(this.expDatePattern).test(expirationDate)) {
      this.showExpDatePatternError = true;
    } else {
      this.showExpDatePatternError = false;
    }

    if (expirationDate !== "" && expirationDate !== null && expirationDate.length === 4) {
      this.isPastDate = false;
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = parseInt(new Date().getFullYear().toString().substring(2, 4));
      const expYear = parseInt(expirationDate.substring(2, 4));
      const expMonth = parseInt(expirationDate.substring(0, 2));
      if (expYear < currentYear) {
        this.isPastDate = true;
      }
      else if (expYear === currentYear && expMonth < currentMonth) {
        this.isPastDate = true;
      }
      else {
        this.isPastDate = false;
      }
    }
    else {
      this.isPastDate = false;
    }
  }

  onChangeCCAuthorization() {
    if (this.orderService.orderDto.ccAuthorizationCode === 'N' && this.orderService.orderDto.orderStatus === 'H') {
      this.orderService.orderDto.orderStatus = ' ';
      this.orderService.orderDto.holdReasonCode = null;
      this.orderService.recalculateFields(this.orderService.orderDto);
    }
  }

  tokenChange() {

    if(this.orderService.orderDto.holdReasonCode==='1')//credit card is declined 
        {
          this.orderService.orderDto.orderStatus = ' ';
          this.orderService.orderDto.holdReasonCode = null;
        }

    if (this.orderService.orderDto.ccToken !== "")
    {
      this.creditCardRequired = false;
    }
    else
    {
      this.creditCardRequired = true;
    }


  }

  async onNgModelTokenChange(encryptedCCString: string): Promise<boolean> {

    if ((encryptedCCString.length === 157 || encryptedCCString.length === 158 || encryptedCCString.length === 177 || encryptedCCString.length === 178)
      && encryptedCCString.endsWith('03')) {
      const equalSign = encryptedCCString.indexOf('=');
      this.orderService.orderDto.ccLastFour = encryptedCCString.substring(equalSign - 4, equalSign);
      const expirationDate = encryptedCCString.substring(equalSign + 1, equalSign + 5);
      const firstSet = encryptedCCString.split("?")[0].split("=");
      const secondSet = firstSet[0].split(";");
      const ccNumber = secondSet[1];

      switch (ccNumber.substring(0, 1)) {
        case "3":
          this.orderService.orderDto.paymentMethod = this.methodList.find(pmeth => pmeth.label === "American Express")?.value!;
          break;
        case "4":
          this.orderService.orderDto.paymentMethod = this.methodList.find(pmeth => pmeth.label === "Visa")?.value!;
          break;
        case "5":
          this.orderService.orderDto.paymentMethod = this.methodList.find(pmeth => pmeth.label === "MasterCard")?.value!;
          break;
        case "6":
          this.orderService.orderDto.paymentMethod = this.methodList.find(pmeth => pmeth.label === "Discover")?.value!;
          break;
        default:
          break;
      }
      await this.onChangePaymentMethod();
      setTimeout(() => {
        this.orderService.orderDto.ccToken = 'Processing, please wait ...';
      });
      setTimeout(() => {
        this._tokenService.getCcToken({ encryptedData: encryptedCCString }).subscribe((data) => {
          if (data.token !== null) {
            this.orderService.orderDto.ccToken = data.token;
            this.orderService.orderDto.ccExpirationDate = expirationDate.substring(2, 4) + expirationDate.substring(0, 2);
            this.expirationDate = expirationDate.substring(2, 4) + '/' + expirationDate.substring(0, 2);
          }
          else {
            this.orderService.orderDto.ccExpirationDate = null;
            this.orderService.orderDto.ccLastFour = "";
            this.expirationDate = '';
            this.creditCardRequired = true;
            this.orderService.orderDto.ccToken = "";
            this.swalAlert.alert('There was an error in fetching the token');
          }
        })
      });
    } else if (encryptedCCString.length === 6) {
      if (this.orderService.orderDto.paymentMethod === 'V' ||
        this.orderService.orderDto.paymentMethod === 'M' ||
        this.orderService.orderDto.paymentMethod === 'D' ||
        this.orderService.orderDto.paymentMethod === 'X') {
        this.orderService.orderDto.paymentTerms = this.creditCardText;
        this.orderService.orderDto.ccAuthorizationCode = 'N';
      }
    }

    return true;
  }
  isPaymentPlanQuarterlyOrMonthly() {
    return this.orderService.orderDto.paymentPlan === 'Monthly' || this.orderService.orderDto.paymentPlan === 'Quarterly';
  }

  onPaymentMethChange() {
    this.orderService.orderDto.paymentMethod = 'C';
  }


  ngOnDestroy(): void {
    this.configIsReadySubscription?.unsubscribe();
    this.orderIsReadySubscription?.unsubscribe();
  }
  
  openGLDialog(): void {
    if (!this.glDialogComponent) {
      return;
    }
    if (this.canEnterEditMode()) {
      this.orderService.onTriggerEdit.next();
  
      // Wait for edit lock to complete, then open dialog
      setTimeout(() => {
        this.glDialogComponent.loadFromDto();
        this.glDialogComponent.openDialog();
      });
    } else {
      this.glDialogComponent.loadFromDto();
      this.glDialogComponent.openDialog();
    }
  }

 
// private getOrderDetailsSafe(): any[] {
//   const dto: any = this.orderService.orderDto ?? {};
//   const arr = dto.orderDetails ?? dto.orderDetailDtos ?? [];
//   return Array.isArray(arr) ? arr : [];
// }


private pick<T = any>(...c: T[]): T | '' {
  for (const x of c) if (x !== undefined && x !== null && x !== '') return x;
  return '' as any;
}
private getGlArray(dto: any): any[] {
  return (dto?.glPayments ?? dto?.glPaymentDtos ?? dto?.glAllocations ?? []) as any[];
}
private firstGlStringFromDto(dto: any): string {
  const a = this.getGlArray(dto);
  if (!Array.isArray(a) || a.length === 0) return '';
  const g = a[0];
  return (this.pick(g.GLString, g.glString, g.gl_code, g['gl-string']) as string).toString().trim();
}
private glCount(dto: any): number {
  const a = this.getGlArray(dto);
  return Array.isArray(a) ? a.length : 0;
}

private syncGLStringFromService(): void {
  const dto: any = this.orderService.orderDto ?? {};
  const count = this.glCount(dto);
  this.glStringError = false;
this.isGLTouched = false;

  if (count === 1) {
    const single = (dto.glPayment && dto.glPayment !== 'Multiple GL Strings exist; edit via click + button.')
      ? dto.glPayment.toString().trim()
      : this.firstGlStringFromDto(dto);
    this.hasMultipleGLs = false;
    this.displayGLString = single;
    dto.glPayment = single;
  } else if (count > 1) {
    this.hasMultipleGLs = true;
    this.displayGLString = 'Multiple GL Strings exist; edit via click + button.';
    dto.glPayment = 'Multiple GL Strings exist; edit via click + button.';
  } else {
    this.hasMultipleGLs = false;
    this.displayGLString = (dto.glPayment ?? '').toString().trim();
  }
}

onChangeGLString(): void {
  if (!this.hasMultipleGLs) {
    this.orderService.orderDto.glPayment = this.displayGLString?.trim?.() ?? '';
  }
}
onGlDialogSave(e: { count: number; firstGLString: string | null }): void {
  if (e.count === 1) {
    this.hasMultipleGLs = false;
    this.displayGLString = (e.firstGLString ?? '').trim();
    this.orderService.orderDto.glPayment = this.displayGLString;
  } else if (e.count > 1) {
    this.hasMultipleGLs = true;
    this.displayGLString = 'Multiple GL Strings exist; edit via click + button';
    this.orderService.orderDto.glPayment = 'Multiple GL Strings exist; edit via click + button'; 
  } else {
    this.hasMultipleGLs = false;
    this.displayGLString = '';
    this.orderService.orderDto.glPayment = '';
  }
}


allowOnlyValidInput(event: KeyboardEvent): void {
  const char = event.key;

  if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(char)) {
    return;
  }

  if (!/^[a-zA-Z0-9]$/.test(char)) {
    event.preventDefault();
    return;
  }

  const cleaned = (this.displayGLString || '').replace(/\s+/g, '');
  const pos = cleaned.length;

  if (pos < 5) {
    if (!/\d/.test(char)) event.preventDefault();
  } else if (pos < 10) {
    if (!/\d/.test(char)) event.preventDefault();
  } else if (pos < 18) {
    // allow alphanumeric
  } else if (pos < 24) {
    const s3 = cleaned.substring(10, 18);
    const hasLetterInS3 = /[A-Z]/.test(s3);

    if (!hasLetterInS3 || !/\d/.test(char)) {
      event.preventDefault();
    }
  } else {
    event.preventDefault();
  }
}


private formatGLString(input: string): { value: string; isValid: boolean } {
  if (!input) return { value: '', isValid: false };

  const cleaned = input.replace(/\s+/g, '').toUpperCase();
  const trimmed = cleaned.substring(0, 24);

  const s1 = trimmed.substring(0, 5);
  const s2 = trimmed.substring(5, 10);
  const s3 = trimmed.substring(10, 18);
  const s4 = trimmed.substring(18, 24);

  const formatted = [s1, s2, s3, s4].filter(Boolean).join(' ');

 const isValid =
  /^\d{5}$/.test(s1) &&
  /^\d{5}$/.test(s2) &&
  /^(?=.*[A-Z])[A-Z0-9]{8}$/.test(s3) && // ✅ MUST contain letter
  /^\d{6}$/.test(s4);

  return { value: formatted, isValid };
}



onMainGLChange(val: string): void {
  if (this.hasMultipleGLs) return;


  const result = this.formatGLString(val);
  this.displayGLString = result.value;

  const cleaned = result.value.replace(/\s+/g, '');

  this.glStringError = this.isGLTouched && (
    cleaned.length > 0 && (
      cleaned.length !== 24 || !result.isValid
    )
  );

  this.orderService.orderDto.glPayment =
    result.isValid && cleaned.length === 24 ? result.value : '';
}
private canEnterEditMode(): boolean {
  const dto = this.orderService.orderDto;
  return (
    this.modeService.mode === Mode.View &&
    dto.orderStatus !== 'V' &&
    dto.orderStatus !== 'P' &&
    dto.orderStatus !== 'D' &&
    !(dto.orderStatus === 'C' && !dto.hasActiveSubscriptions)
  );
}


}
